import { Suspense } from 'react';
import { VenueFileTree } from '@features';
import { Box, Skeleton } from '@mantine/core';

export const VenuesFilesPage: React.FC = () => {
  return (
    <Box py="md">
      <Suspense fallback={<Skeleton height={100} />}>
        <VenueFileTree />
      </Suspense>
    </Box>
  );
};
